export function contentExpand() {
    const collapseBlocks = document.querySelectorAll(".collapse-content-block");

    collapseBlocks.forEach(function(block) {
      const content = block;
      const expandBtn = block.querySelector(".expand-btn");

      expandBtn.addEventListener("click", function() {
        if (block.classList.contains("expanded")) {
          block.classList.remove("expanded");
          block.style.maxHeight = "200px"; // Set your max height here
          expandBtn.textContent = "See More";
        } else {
          block.classList.add("expanded");
          block.style.maxHeight = content.scrollHeight + "px";
          expandBtn.textContent = " ";
        }
      });
    });
}  